import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'

import { getDimensions } from 'helpers/multibrowserHelper'
import TopSection from './TopSection'

import './styles.scss'
const baseClass = 'companyDashboardTop'

class CompanyDashboardTop extends Component {
  state = {
    width: null,
  }

  componentDidMount() {
    this.resizeHandler()
    window.addEventListener('resize', this.resizeHandler)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler)
  }

  resizeHandler = () => {
    const { width } = getDimensions()
    this.setState({ width })
  }

  render() {
    const { t, topActivity, favoriteActivity } = this.props

    if (!topActivity && !(favoriteActivity && favoriteActivity.activity)) {
      return null
    }

    const { width } = this.state
    return (
      <div className={`${baseClass}`}>
        <div className={`${baseClass}__title`}>{t('Top')}</div>
        <div className={`${baseClass}__section`}>
          {topActivity && <TopSection width={width} title={t('Activity')} activity={topActivity} />}

          {favoriteActivity &&
            favoriteActivity.activity && (
              <TopSection
                width={width}
                title={t('Favorite')}
                activity={{
                  ...favoriteActivity.activity,
                  proTrackName: favoriteActivity.proTrackName,
                  rating: favoriteActivity.rating && favoriteActivity.rating.rate,
                }}
              />
            )}
        </div>
      </div>
    )
  }
}

export default withTranslation('user')(CompanyDashboardTop)
